import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-build_icon_add",
  "use": "icon-build_icon_add-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-build_icon_add\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path fill=\"#4D4D4D\" d=\"M20.167 20.167v-11h3.666v11h11v3.666h-11v11h-3.666v-11h-11v-3.666z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol